import { configureStore } from "@reduxjs/toolkit";
import leadsReducer from "./leadsSlice";
import teamReducer from "./teamSlice";
import assetsReducer from "./assetSlice";
import { testimonialsReducer } from "./testimonialSlice";
import cbpReducer from "./cbpSlice";
import faqsReducer from "./faqSlice";
import memberReducer from "./memberSlice";

const store = configureStore({
  reducer: {
    leads: leadsReducer,
    team: teamReducer,
    assets: assetsReducer,
    testimonials: testimonialsReducer,
    cbp: cbpReducer,
    faqs: faqsReducer,
    member: memberReducer
  },
});

export default store;